/* src/app/features/limite-adicional/limite-adicional-por-af/limite-adicional-por-af.component.scss */
.limite-af label {
  font-weight: bold;
}
/*# sourceMappingURL=limite-adicional-por-af.component.css.map */
